import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Utility } from 'src/app/core/common';
import { UtmState } from 'src/app/states/utm.state';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private store: Store, private authService: AuthService, private route: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //skip setting headers if the request is for assets or
    const isAsset = req.url.startsWith(environment.app.assetsUrl);
    if(isAsset) return next.handle(req);

    const token = this.store.selectSnapshot<string>(state => state.auth.token);
    const guestId = this.authService.guestId;
    const utm = Utility.clone(this.store.selectSnapshot(UtmState.utm)) || {};
    utm.kp_url = environment.app.url + this.route.url;
    const options = { withCredentials: true, setHeaders: {} };
    if (guestId) { options.setHeaders['x-kp-guestid'] = guestId; }
    if (token) { options.setHeaders['Authorization'] = token; }
    if (utm) { options.setHeaders['x-utm'] = JSON.stringify(utm); }
    req = req.clone(options);
    return next.handle(req);
  }
}
